import { render, staticRenderFns } from "./OtherUserProfile.vue?vue&type=template&id=43dc17a0&scoped=true"
import script from "./OtherUserProfile.vue?vue&type=script&lang=js"
export * from "./OtherUserProfile.vue?vue&type=script&lang=js"
import style0 from "./OtherUserProfile.vue?vue&type=style&index=0&id=43dc17a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc17a0",
  null
  
)

export default component.exports